import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom'
import { forwardRef } from 'react'

interface LinkProps extends Omit<RouterLinkProps, 'to'> {
  href: string
  preventScroll?: boolean
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ href, preventScroll = true, ...props }, ref) => {
  return <RouterLink to={href} ref={ref} preventScrollReset={preventScroll} {...props} />
})

Link.displayName = 'Link'

export default Link
